<template>
	<nav class="navbar navbar-vertical fixed-start navbar-expand-md navbar-vibrant navbar-dark" id="sidebar">
		<div class="test"></div>
		<div class="container-fluid">
			<button
				class="navbar-toggler"
				type="button"
				data-toggle="collapse"
				data-target="#sidebarCollapse"
				aria-controls="sidebarCollapse"
				aria-expanded="false"
				aria-label="Toggle navigation"
				v-b-toggle.sidebars
			>
				<span class="navbar-toggler-icon"></span>
			</button>
			<!-- Brand -->
			<router-link tag="a" class="navbar-brand" to="/">
				<img src="../../src/assets/img/ubudget.png" class="navbar-brand-img mx-auto" alt="..." />
			</router-link>

			<div class="navbar-user d-md-none">
				<!-- Dropdown -->
				<div class="dropdown">
					<!-- Toggle -->
					<a
						href="#"
						id="sidebarIcon"
						class="dropdown-toggle"
						role="button"
						data-bs-toggle="dropdown"
						aria-haspopup="true"
						aria-expanded="false"
					>
						<b-nav-item-dropdown right style="list-style-type: none">
							<!-- Using 'button-content' slot -->
							<template #button-content>
								<div class="avatar avatar-sm avatar-online">
									<span class="avatar-title rounded-circle avatar-online">{{ fitstLetter(fullname) }}</span>
								</div>
							</template>
							<b-dropdown-item href="#">
								{{ fullname }}
							</b-dropdown-item>
							<hr />
							<b-dropdown-item href="#" @click.prevent="logout"> Logout </b-dropdown-item>
						</b-nav-item-dropdown>
					</a>

					<!-- Menu -->
					<div class="dropdown-menu dropdown-menu-end" aria-labelledby="sidebarIcon">
						<b-link class="dropdown-item" @click="logout">Logout</b-link>
					</div>
				</div>
			</div>

			<!-- Collapse -->
			<div class="collapse navbar-collapse" id="sidebarCollapse">
				<!-- Divider -->
				<!-- <hr class="navbar-divider my-3"> -->

				<!-- Heading -->
				<!-- <h6 class="navbar-heading text-colors text-dark mt-3">
            Health Management System
          </h6> -->

				<!-- Navigation -->
				<ul class="navbar-nav accordion mt-5" style="z-index: 99999999" role="tablist">
					<!--          <li class="nav-item" v-for="(item, index) in filterMenu()" :key="`${item.name}${index}`">-->
					<li class="nav-item" v-for="(item, index) in menus" :key="`${item.name}${index}`">
						<a
							:class="`nav-link text-colors mx-3 ${item.child && item.child.length > 0 && index > 0 ? 'collapsed' : ''} ${
								item.click ? 'isActives text-primary fw-bolder' : 'hovers fw-lighter'
							}`"
							v-b-toggle="item.link"
							data-navtype="parent"
							v-if="item.child && item.child.length > 0"
						>
							<i :class="`fe fe-${item.icon}`"></i>
							{{ item.name }}
						</a>
						<router-link
							tag="a"
							:class="`nav-link text-colors mx-3 ${item.child && item.child.length > 0 && index > 0 ? 'collapsed' : ''} ${
								item.click ? 'isActives text-primary fw-bolder' : 'hovers fw-lighter'
							}`"
							:to="item.child && item.child.length > 0 ? `#${item.link}` : item.link"
							v-else
						>
							<i :class="`fe fe-${item.icon}`"></i>
							{{ item.name }}
						</router-link>
						<!-- ${(item.child && (item.child.length > 0) && index == 0) || item.click ? 'show' : ''} -->
						<b-collapse
							:id="item.child && item.child.length > 0 ? item.link : ''"
							v-if="item.child && item.child.length > 0"
							:visible="item.child && item.child.length > 0 && index == 0"
							accordion="my-accordion"
							role="tabpanel"
						>
							<ul class="nav nav-sm flex-column accordion" role="tablist">
								<li class="nav-item" v-for="(a, i) in item.child" :key="i">
									<a
										:class="`nav-link text-colors mx-3 ${a.child && a.child.length > 0 && index > 0 ? 'collapsed' : ''} ${
											a.click ? 'isActives text-primary fw-bolder' : 'hovers fw-lighter'
										}`"
										v-b-toggle="a.link"
										data-navtype="parent"
										v-if="a.child && a.child.length > 0"
									>
										{{ a.name }}
									</a>
									<router-link
										tag="a"
										:class="`nav-link mx-3 ${a.click ? 'fw-bolder' : 'hovers text-white fw-lighter'}`"
										:to="a.link"
										v-else
									>
										{{ a.name }}
									</router-link>
									<b-collapse
										:id="a.child && a.child.length > 0 ? a.link : ''"
										v-if="a.child && a.child.length > 0"
										:visible="a.child && a.child.length > 0 && index == 0"
										accordion="my-accordion-2"
										role="tabpanel"
									>
										<ul class="nav nav-sm flex-column">
											<li class="nav-item" v-for="(lv3, idx) in a.child" :key="idx">
												<router-link
													tag="a"
													:class="`nav-link mx-3 ${lv3.click ? 'fw-bolder' : 'hovers text-white fw-lighter'}`"
													:to="lv3.link"
												>
													{{ lv3.name }}
												</router-link>
											</li>
										</ul>
									</b-collapse>
								</li>
							</ul>
						</b-collapse>
					</li>
				</ul>

				<!-- Divider -->
				<hr class="navbar-divider my-3" />
			</div>
			<!-- / .navbar-collapse -->
		</div>
		<b-collapse id="sidebars">
			<div class="mt-3 mb-5" style="margin-left: 10px">
				<!--        <ul class="navbar-nav accordion mt-5" style="z-index: 99999999" role="tablist">
&lt;!&ndash;          <li class="nav-item" v-for="(item, index) in filterMenu()" :key="`${item.name}${index}`">&ndash;&gt;
          <li class="nav-item" v-for="(item, index) in menus" :key="`${item.name}${index}`">
            <a :class="`nav-link text-colors mx-3 ${
                    item.child && item.child.length > 0 && index > 0
                      ? 'collapsed'
                      : ''
                  } ${
                    item.click
                      ? 'isActives text-primary fw-bolder'
                      : 'hovers fw-lighter'
                  }`" v-b-toggle="item.link" data-navtype="parent" v-if="item.child && item.child.length > 0">
              <i :class="`fe fe-${item.icon}`"></i>
              {{ item.name }}
            </a>
            <router-link tag="a" :class="`nav-link text-colors mx-3 ${
                    item.child && item.child.length > 0 && index > 0
                      ? 'collapsed'
                      : ''
                  } ${
                    item.click
                      ? 'isActives text-primary fw-bolder'
                      : 'hovers fw-lighter'
                  }`" :to="
                    item.child && item.child.length > 0
                      ? `#${item.link}`
                      : item.link
                  " v-else>
              <i :class="`fe fe-${item.icon}`"></i>
              {{ item.name }}
            </router-link>
            &lt;!&ndash; ${(item.child && (item.child.length > 0) && index == 0) || item.click ? 'show' : ''} &ndash;&gt;
            <b-collapse :id="item.child && item.child.length > 0 ? item.link : ''"
              v-if="item.child && item.child.length > 0" :visible="item.child && item.child.length > 0 && index == 0"
              accordion="my-accordion" role="tabpanel">
              <ul class="nav nav-sm flex-column accordion" role="tablist">
                <li class="nav-item" v-for="(a, i) in item.child" :key="i">
                  <a :class="`nav-link text-colors mx-3 ${
                          a.child && a.child.length > 0 && index > 0
                            ? 'collapsed'
                            : ''
                        } ${
                          a.click
                            ? 'isActives text-primary fw-bolder'
                            : 'hovers fw-lighter'
                        }`" v-b-toggle="a.link" data-navtype="parent" v-if="a.child && a.child.length > 0">
                    {{ a.name }}
                  </a>
                  <router-link tag="a" :class="`nav-link mx-3 ${
                          a.click ? 'fw-bolder' : 'hovers text-white fw-lighter'
                        }`" :to="a.link" v-else>
                    {{ a.name }}
                  </router-link>
                  <b-collapse :id="a.child && a.child.length > 0 ? a.link : ''" v-if="a.child && a.child.length > 0"
                    :visible="a.child && a.child.length > 0 && index == 0" accordion="my-accordion-2" role="tabpanel">
                    <ul class="nav nav-sm flex-column">
                      <li class="nav-item" v-for="(lv3, idx) in a.child" :key="idx">
                        <router-link tag="a" :class="`nav-link mx-3 ${
                                lv3.click
                                  ? 'fw-bolder'
                                  : 'hovers text-white fw-lighter'
                              }`" :to="lv3.link">
                          {{ lv3.name }}
                        </router-link>
                      </li>
                    </ul>
                  </b-collapse>
                </li>
              </ul>
            </b-collapse>
          </li>
        </ul>-->
			</div>
		</b-collapse>
	</nav>
</template>

<script>
import axios from 'axios';
import querystring from 'query-string';
import axiosIns from '@/api/axios';

export default {
	name: 'SidebarComponent',
	data() {
		return {
			fullname: '',
			role_id: '',
			menus: [],
			/*menus: [{
            icon: "home",
            name: "Dashboard",
            link: "/",
          },
          {
            icon: "database",
            name: "Master Data",
            link: "masterData",
            child: [{
                name: "Role",
                link: "/master-data/role",
              },
              {
                name: "Master Budget Type",
                link: "/master-data/master-budget-type",
              },
              // {
              //   name: "Fund Center",
              //   link: "/master-data/fund-center",
              // },
              // {
              //   name: "Fund",
              //   link: "/master-data/fund",
              // },
              // {
              //   name: "Transaction Type",
              //   link: "/master-data/tt-account",
              // },
              // {
              //   name: "Budget Item",
              //   link: "/master-data/tt-budget-item",
              // },
              // {
              //   name: "OPEX GL",
              //   link: "/master-data/opex-gl",
              // },
              // {
              //   name: "CAPEX GL",
              //   link: "/master-data/capex-gl",
              // },
              {
                name: "IM Number",
                link: "/master-data/im-number",
              },
              {
                name: "User",
                link: "/master-data/user",
              },
              {
                name: "Organizations",
                link: "/master-data/org-chart",
              },

            ],
          },
          {
            icon: "git-merge",
            name: "Budget Plan",
            link: "/budget-plan",
          },
          {
            icon: "airplay",
            name: "Budget Realization",
            link: "/monitor-budget",
          },
          {
            icon: "git-commit",
            name: "Budget Monitoring",
            link: "/compare-budget",
          },
          // {
          //   icon: "clock",
          //   name: "Budget Historical",
          //   link: "/history-budget",
          // },
          {
            icon: "clock",
            name: "Historical Log",
            link: "/historical-log",
          },
        ],
        menus0: [{
          icon: "home",
          name: "Home",
          link: "/",
        }, ],*/
		};
	},
	mounted() {
		this.identify();
	},
	methods: {
		/*filterMenu() {
        if (this.role_id === "Super Admin") {
          return this.menus;
        } else if (this.role_id === "Admin") {
          return this.menus.filter((item) => {
            return (
              item.link !== "masterData"
            );
          });
        } else if (this.role_id === "User" || this.role_id === "Viewer") {
          return this.menus.filter((item) => {
            return (
              item.link !== "masterData" &&
              item.link !== "/role-management" &&
              item.link !== "/compare-budget"
            );
          });
        } else if (this.role_id === "0") {
          return this.menus0
        }
      },*/

		fitstLetter(name) {
			return name?.charAt(0);
		},

		async identify() {
			let data = this.$store.getters['role/identity'];
			this.fullname = data?.fullname;
			if (!this.fullname) {
				await this.$store.dispatch('role/GET_IDENTIFY');
				data = this.$store.getters['role/identity'];
			}

			if (data?.roleMap?.roles_id) {
				const response = await axiosIns.get('/master-role/menu/' + data?.roleMap?.roles_id);
				if (response.data.data.length > 1) {
					await Promise.all(
						response.data.data.map(async (itemMenu) => {
							if (itemMenu.items.length > 0 || itemMenu.childs) {
								let child = [];
								for (let key in itemMenu.childs) {
									if (itemMenu.childs[key].items.length > 0) {
										child.push({
											name: itemMenu.childs[key].name,
											link: itemMenu.childs[key].link,
											authorization: itemMenu.childs[key].items[0]?.authorization
												? itemMenu.childs[key].items[0]?.authorization
												: null,
										});
									}
								}
								if (child.length > 0) {
									this.menus.push({
										icon: itemMenu.icon,
										name: itemMenu.name,
										link: itemMenu.link,
										child: child,
									});
								}
								if (itemMenu.items.length > 0) {
									this.menus.push({
										icon: itemMenu.icon,
										name: itemMenu.name,
										link: itemMenu.link,
									});
								}
							}
						})
					);
				}
			}
			if (data?.roles_uenroll.length) {
				this.role_id = data.roles_uenroll[0];
				// localStorage.setItem("role_id", data.roleMap.roles_id);
				localStorage.setItem('roles', data?.roles_uenroll[0]);
				this.$root.$emit('role_id', data?.roles_uenroll[0]);
				localStorage.setItem('permission', true);
			} else {
				/*
            this.role_id = 0
            localStorage.setItem("role_id", this.role_id);
            this.$root.$emit("role_id", 'None');
            localStorage.setItem("roles", 'None');
            localStorage.setItem("permission", false);
            */
				try {
					this.$router.push('/');
					const logout_url = `${process.env.VUE_APP_KEYCLOAK_URL}/realms/${
						process.env.VUE_APP_KEYCLOAK_REALM || 'ugems'
					}/protocol/openid-connect/logout`;
					const client_id = process.env.VUE_APP_KEYCLOAK_CLIENT_ID || 'url-shortener';
					const access_token = localStorage.getItem('ugems-accessToken');
					const refresh_token = localStorage.getItem('ugems-refreshToken');
					const payload = querystring.stringify({
						client_id,
						refresh_token,
					});

					const headers = {
						'Content-Type': 'application/x-www-form-urlencoded',
						Authorization: access_token,
					};

					await axios.post(logout_url, payload, headers);
					localStorage.removeItem('role_id');
					localStorage.removeItem('roles');
					localStorage.removeItem('permission');
					localStorage.removeItem('ugems-accessToken');
					localStorage.removeItem('ugems-refreshToken');
					localStorage.removeItem('ugems-tokenParsed');
					window.location.reload();
				} catch (err) {
					console.log('Error on logout', err);
				}
			}
		},

		/*navClick(link) {
        const idx = this.menus.findIndex((e) => e.link === link);
        if (this.menus[idx].child) {
          let selected = this.menus[idx];

          if (this.$refs[selected.link][0].classList.contains("collapsed")) {
            this.$refs[selected.link][0].classList.remove("collapsed");
          }
        }
      },*/

		async logout() {
			try {
				this.$router.push('/');
				const logout_url = `${process.env.VUE_APP_KEYCLOAK_URL}/realms/${
					process.env.VUE_APP_KEYCLOAK_REALM || 'ugems'
				}/protocol/openid-connect/logout`;
				const client_id = process.env.VUE_APP_KEYCLOAK_CLIENT_ID || 'url-shortener';
				const access_token = localStorage.getItem('ugems-accessToken');
				const refresh_token = localStorage.getItem('ugems-refreshToken');
				const payload = querystring.stringify({
					client_id,
					refresh_token,
				});

				const headers = {
					'Content-Type': 'application/x-www-form-urlencoded',
					Authorization: access_token,
				};

				await axios.post(logout_url, payload, headers);
				localStorage.removeItem('role_id');
				localStorage.removeItem('roles');
				localStorage.removeItem('permission');
				localStorage.removeItem('ugems-accessToken');
				localStorage.removeItem('ugems-refreshToken');
				localStorage.removeItem('ugems-tokenParsed');
				window.location.reload();
			} catch (err) {
				console.log('Error on logout', err);
			}
		},
	},
};
</script>

<style></style>
